import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { PipesModule } from 'src/pipes/pipes.module';
import { MyAscentListEntry } from '../../model/my-ascent-list-entry';
import { BoulderDetailsPage } from '../../pages/boulder-details/boulder-details.page';
import { SortByDatePipe } from '../../pipes/sort-by-date.pipe';
import { BoulderService } from '../../services/boulder.service';
import { getScore, MAX_BOULDERS_USED_FOR_SCORE } from '../../services/ranking.service';
import { AscentListEntryComponent } from '../ascent-list-entry/ascent-list-entry.component';

@Component({
  standalone: true,
  imports: [IonicModule, FormsModule, CommonModule, PipesModule, TranslateModule, AscentListEntryComponent],
  selector: 'my-ascent-list',
  templateUrl: './my-ascent-list.component.html',
  styleUrls: ['./my-ascent-list.component.scss']
})
export class MyAscentListComponent implements OnInit {

  @Input('username')
  username: string;

  ascents: MyAscentListEntry[];
  numFlashed = 0;

  totalScore = 0;
  onlyRanking = false;
  maxBoulderInRanking = MAX_BOULDERS_USED_FOR_SCORE;

  constructor(
    private boulderService: BoulderService,
    private modalCtrl: ModalController) {
  }

  ngOnInit() {
    this.reloadAscents();
  }


  async reloadAscents() {
    this.ascents = null;
    this.ascents = await this.computeAscents();
    this.numFlashed = this.ascents.filter(a => a.flash).length;
  }

  private async computeAscents(): Promise<MyAscentListEntry[]> {
    const boulders = await firstValueFrom(this.boulderService.getBoulders$());
    let ascents = boulders.map(b => b.ascents.filter(a => a.userName === this.username).map(ascentListEntry => {
      return new MyAscentListEntry(b.boulderId, b.boulderName, b.grade, ascentListEntry.date, ascentListEntry.flash, getScore(b.grade, ascentListEntry.flash));
    })).reduce((prev, current) => [...prev, ...current], []);
    if (this.onlyRanking) {
      ascents.sort(
        (a, b) => a.score == b.score ? 0 : a.score > b.score ? -1 : 1);
      ascents = ascents.slice(0, this.maxBoulderInRanking);
      this.totalScore = ascents.map(a => a.score).reduce((a, b) => a + b);
    } else {
      ascents.sort((a, b) => SortByDatePipe.compareDates(a.date, b.date));
    }
    return ascents;
  }

  async showBoulder(boulderId: string, ascents) {
    const modal = await this.modalCtrl.create({
      component: BoulderDetailsPage,
      componentProps: { boulderId: boulderId, boulderIds: ascents.map(a => a.boulderId) }
    });
    return await modal.present();
  }

  async onRefresh(event) {
    try {
      this.reloadAscents();
    } finally {
      if (event) {
        event.target.complete();
      }
    }
  }

}
